import { useState, useEffect } from "react";
import { useTypeSelectors } from "./useTypeSelectors";
import { UserData } from "types/User";
import { ScheduleReport } from "types/Schedule";

export const useGetByHelperOf = (date: string | undefined, id: number | null | undefined) => {
  const { dataList, userList } = useTypeSelectors((state) => state.scheduleTable);
  const [helperOfReport, setHelperOfReport] = useState<ScheduleReport | undefined | null>(undefined);
  const [helperOf, sethelperOf] = useState<UserData | undefined | null>(undefined);

  useEffect(() => {
    if (id) {
      const report = dataList?.find(
        (report) => report.schedule_date === date && report.assigned_to === id,
      );
      setHelperOfReport(report)
      sethelperOf(userList.find((user) => user.id === report?.assigned_to));
    } else {
      setHelperOfReport(null)
      sethelperOf(null)
    }
  }, [id, dataList, userList, date]);

  return {
    helperOfReport,
    helperOf,
  };
};
